import Alert from '@customink/pigment-react/lib/components/Alert';
import Link from '@customink/pigment-react/lib/components/Link';
import { useEffect } from 'react';

import { CustomerCareNumber, WCIBMO_NAMES } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { pageViewTag } from '@/utils/metrics';

export default function UsToCanada() {
  const quantityType = useOrderQuantityType();

  useEffect(() => {
    pageViewTag(
      `checkout/summary/${quantityType}/wcibmo/${WCIBMO_NAMES.US_PRODUCT_TO_CANADA}`,
    );
  }, [quantityType]);

  const customerCareLink = (
    <>
      {' '}
      <Link href={`tel:${CustomerCareNumber}`}>{CustomerCareNumber}</Link>{' '}
    </>
  );
  return (
    <Alert severity="warning">
      <strong> We are unable to ship this item to Canada.</strong> Please give
      us a call at {customerCareLink}
      and have a representative help you place your order, update your shipping
      address to a Canadian address, or swap to one of our products from our
      Available in Canada category.
    </Alert>
  );
}
